<div class="accordion mb-3" [attr.id]="tabbedAccordionId">
    <div class="accordion-item">
        <h2 class="accordion-header">
            <button class="accordion-button collapsed" [ngClass]="customHeaderClass" type="button" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapseOne' + tabbedAccordionId" aria-expanded="false"
                [attr.aria-controls]="'collapseOne' + tabbedAccordionId">
                <div class="d-flex flex-fill align-items-center">
                    <img [src]="accordionIcon" class="me-2" />
                    <span>{{tabbedAccordionTitle}}</span>
                </div>
                <div class="d-flex flex-fill align-items-center justify-content-end gap-2 me-2">
                    <i class="bi-check-circle-fill accordion__status" [class.accordion__status--success]="hasValues"></i>
                    <i class="bi-x-circle-fill accordion__status"></i>
                </div>
            </button>
        </h2>
        <div [attr.id]="'collapseOne' + tabbedAccordionId" class="accordion-collapse collapse"
            [attr.data-bs-parent]="'#' + tabbedAccordionId">
            <div class="accordion-body">
                <ng-container *ngIf="singleInput; else tabsTemplate">
                    <div class="single-input-body d-flex align-items-center justify-content-between" [formGroup]="form">
                        <label class="w-100">{{ singleInputLabel }}</label>
                        <div class="input-group">
                            <span class="">$</span>
                            <input type="text" class="form-control" (keypress)="allowNumbersOnly($event)"
                                (input)="cleanNonNumbers($event)"
                                [formControlName]="detailedFields[0].key" placeholder="0.00">
                        </div>
                    </div>
                </ng-container>
                <ng-template #tabsTemplate>
                <ul class="nav nav-tabs" role="tablist" [attr.id]="tabId + tabbedAccordionId">
                    <li class="nav-item flex-fill">
                        <button class="nav-link w-100" [class.active]="activeTab === 1" type="button" role="tab" data-bs-toggle="tab"
                            [attr.id]="tabId + tabbedAccordionId + 'TotalTab'"
                            [attr.data-bs-target]="'#' + tabId + tabbedAccordionId + 'Total'"
                            [attr.aria-controls]="tabId + tabbedAccordionId + 'Total'" [attr.aria-selected]="activeTab === 1" (shown.bs.tab)="onSelectTab(1)">
                            <i class="bi bi-circle me-2" [class.bi-record-circle-fill]="activeTab === 1"></i> {{ (type === 'nonProductiveAssets' || type === 'productiveAssets' || type === 'liabilities') ? 'Total' : (tabTitle | titlecase) + ' total' }}
                        </button>
                    </li>
                    <li class="nav-item flex-fill">
                        <button class="nav-link w-100" [class.active]="activeTab === 2" type="button" role="tab" data-bs-toggle="tab"
                            [attr.id]="tabId + tabbedAccordionId + 'DetalleTab'"
                            [attr.data-bs-target]="'#' + tabId + tabbedAccordionId + 'Detalle'"
                            [attr.aria-controls]="tabId + tabbedAccordionId + 'Detalle'" [attr.aria-selected]="activeTab === 2" (shown.bs.tab)="onSelectTab(2)">
                            <i class="bi bi-circle me-2" [class.bi-record-circle-fill]="activeTab === 2"></i> {{ (type === 'nonProductiveAssets' || type === 'productiveAssets' || type === 'liabilities') ? 'Detallado' : (tabTitle | titlecase) + ' detallado' }}
                        </button>
                    </li>
                </ul>
                <div class="tab-content" [attr.id]="tabId + tabbedAccordionId + 'Content'">
                    <div class="tab-pane fade" [class.show]="activeTab === 1" [class.active]="activeTab === 1" [attr.id]="tabId + tabbedAccordionId + 'Total'"
                        role="tabpanel" [attr.aria-labelledby]="tabId + tabbedAccordionId + 'TotalTab'" tabindex="0">
                        <div class="">
                            <div *ngIf="type === 'trips'">
                                <div class="d-flex align-items-center justify-content-between" [formGroup]="form">
                                    <label class="w-100">Total de {{tabTitle}} anuales</label>
                                    <div class="input-group" [class.is-mark]="isMarkField(detailedFields[0].key)">
                                        <span class="">$</span>
                                        <input type="text" class="form-control" (keypress)="allowNumbersOnly($event)"
                                            (input)="cleanNonNumbers($event)"
                                            [formControlName]="detailedFields[0].key" placeholder="0.00">
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between">
                                    <label class="w-100">Total de {{tabTitle}} mensuales</label>
                                    <div class="input-group" [class.is-mark]="isMarkTotal()">
                                        <span class="">$</span>
                                        <input *ngIf="type === 'trips'" type="text" class="form-control" [value]="((total$ | async) ?? 0) / 12 | number:'1.2-2'" readonly>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="type !== 'trips'" class="d-flex align-items-center justify-content-between" [formGroup]="form">
                                <label class="w-100">{{ totalLabel }}</label>
                                <div class="input-group" [class.is-mark]="isMarkField(detailedFields[0].key)">
                                    <span class="">$</span>
                                    <input type="text" class="form-control" (keypress)="allowNumbersOnly($event)"
                                            (input)="cleanNonNumbers($event)"
                                        [formControlName]="detailedFields[0].key" placeholder="0.00">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" [class.show]="activeTab === 2" [class.active]="activeTab === 2" [attr.id]="tabId + tabbedAccordionId + 'Detalle'"
                        role="tabpanel" [attr.aria-labelledby]="tabId + tabbedAccordionId + 'DetalleTab'" tabindex="0">
                        <div>
                            <div class="d-flex flex-column align-items-center justify-content-between gap-2 mb-2" [formGroup]="form">
                                <div *ngFor="let field of detailedFields.slice(1, detailedFields.length)"
                                    class="w-100 d-flex align-items-center justify-content-between">
                                    <label class="w-100">{{ field.label | titlecase}}</label>
                                    <div class="input-group" [class.is-mark]="isMarkField(field.key)">
                                        <span class="">$</span>
                                        <input type="text" class="form-control" [formControlName]="field.key" placeholder="0.00" (keypress)="allowNumbersOnly($event)"
                                            (input)="cleanNonNumbers($event)">
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane__total">
                                <div *ngIf="type === 'trips'" class="d-flex align-items-center justify-content-between mb-2">
                                    <label class="w-100">Total de {{tabTitle}} anuales</label>
                                    <div class="input-group" [class.is-mark]="isMarkTotal()">
                                        <span class="">$</span>
                                        <input type="text" class="form-control" [value]="((total$ | async) ?? 0) | number:'1.2-2'" readonly>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between">
                                    <label class="w-100">{{ totalLabel }}</label>
                                    <div class="input-group" [class.is-mark]="isMarkTotal()">
                                        <span class="">$</span>
                                        <input *ngIf="type === 'trips'" type="text" class="form-control" [value]="((total$ | async) ?? 0) / 12 | number:'1.2-2'" readonly>
                                        <input *ngIf="type !== 'trips'" type="text" class="form-control" [value]="((total$ | async) ?? 0) | number:'1.2-2'" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>